var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nv-new-line"},_vm._l(((_vm.lineNumber - 1)),function(item){return _c('div',{staticClass:"nv-new-line_item"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }